import { createAction } from 'redux-actions';
import * as Api from './api';

const deleteSuccess = createAction('DELETE_ATTACHMENT_SUCCESS');
export const deleteAttachment = ({ id, ...config }) => async dispatch => {
  const response = await Api.deleteAttachment(id, config);
  dispatch(deleteSuccess(id));
  return response;
};
